import { HelpContent } from '../../../../../UI-Lib/Help-Tooltip';

export const RETURN_PREVIEW_FORM_OVERRIDES_HELP: HelpContent[] = [
    {
        helpContentId: 'return-preview-form-overrides.show-all-overrides',
        tooltipText: 'Shows the list of overrides for any form in the list.'
    }
];
